<template>
 <div class="com-bottom side-panel top mapBg osy" style="left:25%;">
    <div class="side-panel-bg pt-20 mb-20">
      <div class="side-panel-content ">
        <h1 class="titleIcon f-20 c-satwo p-20"><img src="/imgs/titleicon1.png" class="mr-15">建设单位：新疆联合智算<img src="/imgs/titleicon.png" class="ml-10"></h1>
        <div class="fr ov comCenterIndex">
          <!-- <div v-for="(panel, index) in dcStatistics" :key="index" class="f1 tc" :class="panelClasses[index]">
            <div class="f-18 pt-10">{{ panel.mainValue }}</div>
            <div class="f-12 pt-5">{{ panel.subValue }}</div>
            <div class="f-12 pt-20 c-bgyanse b">{{ panel.title }}</div>
          </div> -->
          <!-- 第一个面板 -->
            <div class="f1 tc" :class="panelClasses[0]">
              <div class="f-16">{{ dcStatistics[0].mainValue }} <span class="f-10"></span></div>
              <div class="f-16 pt-5">{{ dcStatistics[0].subValue }} <span class="f-10">在用</span></div>
              <div class="f-12 pt-20 c-base">{{ dcStatistics[0].title }}</div>
            </div>

            <!-- 第二个面板 -->
            <div class="f1 tc" :class="panelClasses[1]">
              <div class="f-16">{{ dcStatistics[1].mainValue }} <span class="f-10"></span></div>
              <div class="f-16 pt-5">{{ dcStatistics[1].subValue }} <span class="f-10">在用</span></div>
              <div class="f-12 pt-20 c-base">{{ dcStatistics[1].title }}</div>
            </div>

            <!-- 第三个面板 -->
            <div class="f1 tc" :class="panelClasses[2]">
              <div class="f-18">{{ dcStatistics[2].mainValue }}</div>
              <div class="f-16 pt-5">{{ dcStatistics[2].subValue }}</div>
              <div class="f-12 pt-20 c-base">{{ dcStatistics[2].title }}</div>
            </div>

            <!-- 第四个面板 -->
            <div class="f1 tc" :class="panelClasses[3]">
              <div class="f-16">{{ dcStatistics[3].mainValue }} <span class="f-10"></span></div>
              <div class="f-16 pt-5">{{ dcStatistics[3].subValue }} <span class="f-10">在用</span></div>
              <div class="f-12 pt-20 c-base">{{ dcStatistics[3].title }}</div>
            </div>

            <!-- 第五个面板 -->
            <div class="f1 tc" :class="panelClasses[4]">
              <div class="f-16">{{ dcStatistics[4].mainValue }} <span class="f-10">网络</span></div>
              <div class="f-16 pt-5">{{ dcStatistics[4].subValue }} <span class="f-10">带宽</span></div>
              <div class="f-12 pt-20 c-base">{{ dcStatistics[4].title }}</div>
            </div>

            <!-- 第六个面板 -->
            <div class="f1 tc" :class="panelClasses[5]">
              <div class="f-16">{{ dcStatistics[5].mainValue }} <span>TB</span></div>
              <div class="f-16 pt-5">{{ dcStatistics[5].subValue }} <span class="f-10">IO</span></div>
              <div class="f-12 pt-20 c-base">{{ dcStatistics[5].title }}</div>
            </div>
        </div>
        <div class="comCenterGpu mt-20">
          <div style="width: 50%; float: left; height: 100%;">
            <div style="position: absolute;top: 23px;left: 160px; font-size: 16px;">
              <p>采用 NVIDIA Hopper 架构 GPU</p>
            </div>
            <div style="position: absolute;top: 55px; left: 160px;">
              <div class="fr ae">
                <div class="spec-label"><p>FP16 Tenser Core</p></div>
                <div class="spec-value"><p>1,979</p></div>
                <div class="spec-unit"><p>teraFLOPS</p></div>
              </div>
              <div class="fr ae mt-5">
                <div class="spec-label"><p>FP8 Tenser Core</p></div>
                <div class="spec-value"><p>3,958</p></div>
                <div class="spec-unit"><p>teraFLOPS</p></div>
              </div>
              <div class="fr ae mt-5">
                <div class="spec-label"><p>INT8 Tenser Core</p></div>
                <div class="spec-value"><p>3,958</p></div>
                <div class="spec-unit"><p>TOPS</p></div>
              </div>
              <div class="fr ae mt-5">
                <div class="spec-label"><p>显存</p></div>
                <div class="spec-value"><p>80</p></div>
                <div class="spec-unit"><p>GByte</p></div>
              </div>
              <div class="fr ae mt-5">
                <div class="spec-label"><p>显存带宽</p></div>
                <div class="spec-value"><p>3.35</p></div>
                <div class="spec-unit"><p>TB/s</p></div>
              </div>
            </div>
            <div class="fr ac" style="height:100%; margin-left: 20px;">
              <img src="/imgs/GPU.png"  alt="Advantage GPU" style="width:122px; height:104px;" />
            </div>
<!--            <chart-rosetwo :data="chipDistribution" style="height:158px;"></chart-rosetwo>-->
          </div>
          <div class="nengRt">
            <div>能耗</div>
            <div class="fr">
              <div style="width: 180px;">设计容量：<span class="c-bgyanse1">{{energyData.capacity}}</span></div>
              <div>绿电占比：<span class="c-bgyanse1">{{energyData.green_electricity}}</span></div>
            </div>
            <div class="fr">
              <div style="width: 180px;">当前功耗：<span class="c-bgyanse1">{{energyData.power_consumption}}</span></div>
              <div>PUE：<span class="c-bgyanse1">{{energyData.PUE}} </span></div>
            </div>
            <div>
              <chart-line-power :chartData="energyPower" style="width: 100%; height: 130px;" />
            </div>
          </div>
        </div>

      </div>
    </div>
    <div class="side-panel-bg p-20">
      <h1 class="titleIcon f-20 c-satwo">
        <img src="/imgs/titleicon1.png" class="mr-15">实时事件处置<img src="/imgs/titleicon.png" class="ml-10">
      </h1>
      <div id="publishMain" class="centerNews">
        <div id="publishMain1">
          <div class="centerNewsCon" v-for='(news , index) in warningList' :key ='index'>
            <div
              class="centerNewsContitle f-12 pt-5"
              :style="{ color: colors[index % colors.length] }"
            >
              {{news.data}} {{news.title}}</div>
            <div class="f-14 ellipsisBox"> {{news.content}}</div>
            <div class="blikunnewsicon">处置</div>
          </div>
        </div>
        <div id="publishMain2"></div>
      </div>
    </div>
 </div>
</template>

<script>
import chartRosetwo from './chart-rosetwo'
import chartLinePower from "@/views/sascreen/dc/chart-line-power.vue";

export default {
  name: "VideoDetail",
  components: {
    chartRosetwo,
    chartLinePower,
  },
  props: {
    resData: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      dcStatistics:{},
      chipDistribution:{},
      energyData:{},
      warningList:[],
      energyPower: {},

      colors: ['#A9FF99', '#DF9BFF', '#FFF5C3'],// 颜色列表
      designCapacity: 40000, // 设计容量 (单位：KW)
      greenPowerPercentage: 75, // 绿电占比 (百分比)
      ratedPowerConsumption: 13824, // 已投入设备额定能耗 (单位：KW)
      // 定义面板的样式类
      panelClasses: [
        'sabgicon1 c-bgyanse2',
        'sabgicon2 c-bgyanse2',
        'sabgicon1 c-bgyanse2',
        'sabgicon2 c-bgyanse2',
        'sabgicon1 c-bgyanse2',
        'sabgicon2 c-bgyanse2'
      ]
    };
  },
  created() {
    //获取视频地址
    // this.request("/file/detail/" + id).then(res => {
    //    this.playerOptions.sources[0].src = res.data.url
    // })
  },
  mounted () {
    this.$nextTick(function () {
      // 初始化dom相关数据
      setTimeout(()=>{// 136px 143px
        this.dcStatistics = this.resData.dcStatistics
        this.chipDistribution = this.resData.chipDistribution
        this.energyData = this.resData.energyData
        this.warningList = this.resData.warningList
        this.energyPower = this.resData.energyPower
      },300)
    })
  },
}
</script>

<style scoped>
.spec-label {
  color: #FFF;
  font-size: 14px;
  width: 125px;
  height: 22px;
  display: flex;
  flex-direction: column; /* 设置主轴为垂直方向 */
  justify-content: flex-end; /* 将内容对齐到主轴的末端，即底部 */
}
.spec-value {
  color: #66FFFF;
  font-family: Consolas, monospace;
  font-size: 18px;
  margin-right: 10px;
  height: 22px;
  display: flex;
  flex-direction: column; /* 设置主轴为垂直方向 */
  justify-content: flex-end; /* 将内容对齐到主轴的末端，即底部 */
}
.spec-unit {
  color: #66FFFF;
  font-size: 12px;
  height: 22px;
  display: flex;
  flex-direction: column; /* 设置主轴为垂直方向 */
  justify-content: flex-end; /* 将内容对齐到主轴的末端，即底部 */
}

.side-panel-content{
  background: url(/imgs/saCenter_bg.png) no-repeat center;
  height: 560px;
}
.comCenterIndex{
  margin: 0 55px;
  height:147px;
  background: url(/imgs/dcsaCenter_gpubg.png) no-repeat center;
  padding-top: 43px;
}
.titleIcon{
  font-size: 21px;
  color: #19ECFF;
  letter-spacing: 4.2px;
  line-height: 33px;
  font-weight: 500;
  text-align: center;
}
.sabgicon1{
  background: url(/imgs/dcprojectimgbg1.png) no-repeat center;
  height: 143px;
  margin-right: 10px;
}
.sabgicon2{
  background: url(/imgs/dcprojectimgbg2.png) no-repeat center;
  height: 143px;
  margin-right: 10px;
}
.c-bgyanse1{
  color: #00ECFF;
  font-size: 16px;
  margin-right: 20px;
  font-family: Consolas, monospace;
}
.c-bgyanse2{
  color: #66FFFF;
}
.c-base{
  color:#fff
}
.comCenterGpu{
  height:205px;
  background-image: linear-gradient(-62deg, rgb(28, 45, 97, 0.1) 0%, rgb(92,221, 223,0.1) 95%);
  border-radius: 4px;
  margin: 55px 90px;
  position: relative;
  overflow: hidden;
}

.nengRt{
  margin-left: 20px;
  width: 46%;
  float: right;
  margin-top:14px;
}
.nengRt div{
  line-height: 20px;
}


.listModleLeft{
  overflow: hidden;
  padding-bottom: 10px;
  margin: 0 10px;
}
.listModleLeftContent{
  float: left;
  margin: 20px 24px 0 0;
  width: 48%;
  height: 125px;
  background: url(/imgs/salist-centerbg.png) no-repeat;
  background-size: 100% 100%;
  padding: 0px 0 0 30px;
}
.listModleLeftContent:nth-child(2n){
  margin-right: 0;
}
.listModleLeftContent div{
  line-height: 26px;
  font-size: 16px;
}
.listModleLeftContent div span{
  margin-right: 5px;
}

.listModleLeftContent h3{
  font-size: 14px;
}

.newsList{
  padding-right: 0;
}
.centerNews{
  width:100%;
  height:270px;
  overflow-y: scroll;
  margin: 8px 0 0px;
}
.centerNewsCon{
  margin-top:10px;
  padding: 0 10px;
  width:100%;
  height:55px;
  background:url("/imgs/blikunnewsbg.png") no-repeat;
  background-size:100% 55px;
  position: relative;
}
.centerNewsCon .centerNewsContitle{
  width: 50%;
  height: 24px;
  line-height: 22px;
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 5px;
}

.centerNewsCon .ellipsisBox{
  list-style-type: disc;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 20px;
  margin-top: 5px;
}
.centerNewsCon .blikunnewsicon{
  position: absolute;
  right: 20px;
  top: 15px;
  border: 1px solid rgba(0,253,253,1);
  border-radius: 2px;
  font-size: 14px;
  color: #00FDFD;
  font-weight: 400;
  padding: 2px 16px;
}
#publishMain1{
  width: 100%;
}
.f-10{
  font-size: 10px;
}

</style>
